import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import NiceModal from '@ebay/nice-modal-react'
import ReportIncidentModal from 'components/ReportIncidentModal'

const ReportIncident = ({ task, refetch }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    NiceModal.show(ReportIncidentModal, { task })
      .then(refetch)
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <Menu.Item key='reportIncident' >
      {(props) => (
        <MenuButton {...props} onClick={onClick}>
          { formatMessage(messages.reportIncident) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default ReportIncident
